import React from 'react';
import PropTypes from 'prop-types';
import { Time, Location } from 'sushiweb/Icons';
import { getTimeIn12HRFormat, formatDays } from '../../helpers';
import { locationRestrictionLabels } from '../../pages/common/components/constants';
import ExpandableSection from '../ExpandableSection';
import {
    InfoGrid,
    InfoRow,
    InfoLabel,
    InfoValue,
} from '../common/styles';
import ListInfoModal from './ListInfoModal';

const SlotItem = ({ slot, slotIndex }) => {
    const timeRange = `${getTimeIn12HRFormat(slot.start_time)} – ${getTimeIn12HRFormat(slot.end_time)}`;

    const header = (
      <InfoLabel>
        <Time size={14} />
        {' Slot '}
        {slotIndex + 1}
        {': '}
        {timeRange}
      </InfoLabel>
    );

    return (
      <ExpandableSection header={header}>
        <InfoGrid indented>
          <InfoRow>
            <InfoLabel>Slot Budget</InfoLabel>
            <InfoValue>{slot.amount ? `₹${slot.amount}` : 'NA'}</InfoValue>
          </InfoRow>

          <InfoRow>
            <InfoLabel>Per Order Limit</InfoLabel>
            <InfoValue>{slot.per_order_amount ? `₹${slot.per_order_amount}` : 'NA'}</InfoValue>
          </InfoRow>

          <InfoRow>
            <InfoLabel>Active Days</InfoLabel>
            <InfoValue>{formatDays(slot.days)}</InfoValue>
          </InfoRow>

          <InfoRow>
            <InfoLabel>Location Restrictions</InfoLabel>
            <InfoValue>
              <ListInfoModal
                items={slot.locations}
                itemLabel="location"
                modalTitle={slot.locations[0]?.apl_rule === 2 ? locationRestrictionLabels.PROHIBITED : locationRestrictionLabels.PERMITTED}
                getItemText={loc => loc?.address || 'Unknown location'}
                renderIcon={() => <Location size={14} />}
              />
            </InfoValue>
          </InfoRow>
        </InfoGrid>
      </ExpandableSection>
    );
};

SlotItem.propTypes = {
    slot: PropTypes.objectOf(PropTypes.any).isRequired,
    slotIndex: PropTypes.number.isRequired,
};

export default SlotItem;
